<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();

const isEnabled = ref(false);
const isSubmitting = ref(false);

watch(
  currentAccount,
  () => {
    isEnabled.value =
      !!currentAccount.value?.settings?.enforce_attendance_isolation;
  },
  { deep: true, immediate: true }
);

const handleToggle = async () => {
  try {
    isSubmitting.value = true;
    await updateAccount(
      { enforce_attendance_isolation: isEnabled.value },
      { silent: true }
    );
    useAlert(t('GENERAL_SETTINGS.FORM.ATTENDANCE_ISOLATION.API.SUCCESS'));
  } catch (error) {
    isEnabled.value = !isEnabled.value;
    useAlert(t('GENERAL_SETTINGS.FORM.ATTENDANCE_ISOLATION.API.ERROR'));
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <section class="flex flex-col w-full">
    <div class="flex items-start justify-between gap-4">
      <div class="flex flex-col">
        <h3 class="text-sm font-medium text-n-slate-12 mb-1">
          {{ t('GENERAL_SETTINGS.FORM.ATTENDANCE_ISOLATION.LABEL') }}
        </h3>
        <p class="text-sm text-n-slate-11 mb-0">
          {{ t('GENERAL_SETTINGS.FORM.ATTENDANCE_ISOLATION.HELP_TEXT') }}
        </p>
      </div>
      <Switch
        v-model="isEnabled"
        :disabled="isSubmitting"
        @change="handleToggle"
      />
    </div>
  </section>
</template>
